import { useRef, useState } from "react";

export const useUndo = (limit = 50) => {
  const history = useRef([]);
  const [canUndo, setCanUndo] = useState(false);

  const record = (undoCallback) => {
    history.current.push(undoCallback);

    if (history.current.length > limit) {
      history.current.shift();
    }

    setCanUndo(history.current.length > 0);
  };

  const undo = () => {
    const cb = history.current.pop();
    if (cb) cb();
    setCanUndo(history.current.length > 0);
  };

  const resetUndo = () => {
    history.current = [];
    setCanUndo(false);
  };

  return { record, undo, canUndo, resetUndo };
};
